import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../../../core/environment.tokens";
import { MenuItem } from "../../../../../../shared/menu/menu-item.model";
import { RetrievalModule } from "../../../retrieval.module";

@Injectable()

export class EmrDetailHeaderService {
  reset = new Subject<any>();
  resetHeaderMenu = new Subject<any>();

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService,
    private route: ActivatedRoute
  ) { }

  getEmrGdFromPath(): number {
    return this.route.snapshot.firstChild.firstChild.firstChild.params.EmrGd;
  }

  getCallTypeFromPath(): string {
    return this.route.snapshot.firstChild.firstChild.firstChild.children[0].params.callType;
  }

  resetEmr(emrId: number) {

    this.reset.next(emrId);
  }

  resetSubMenu(callTabVisible: boolean) {
    this.resetHeaderMenu.next(callTabVisible);
  }

  getMenuItems(): Observable<MenuItem[]> {
    const url = `${this.baseApiUrl}EMR/MenuItems`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default-sub-menu", "MenuItem"))
    );
  }

}
